import { getText } from '../internal/TextLabels'

export const Roles = {
  SUPER_USER: 'SUPER_USER',
  STORE_MANAGER: 'STORE_MANAGER',
  STORE_SALES: 'STORE_SALES',
  STORE_SALES_LIMITED: 'STORE_SALES_LIMITED',
  FINANCE: 'FINANCE',
  WAREHOUSE: 'WAREHOUSE',
  RESURS_ADMIN: 'RESURS_ADMIN',
}

export class RoleLabels {
  constructor() {
    this.labels = {}
    this.icons = {}
    this.colors = {}

    this.labels[Roles.SUPER_USER] = getText('user.roles.superUser')
    this.labels[Roles.STORE_MANAGER] = getText('user.roles.storeManager')
    this.labels[Roles.STORE_SALES] = getText('user.roles.storeSales')
    this.labels[Roles.STORE_SALES_LIMITED] = getText(
      'user.roles.storeSalesLimited',
    )
    this.labels[Roles.FINANCE] = getText('user.roles.finance')
    this.labels[Roles.WAREHOUSE] = getText('user.roles.warehouse')
    this.labels[Roles.RESURS_ADMIN] = getText('user.roles.resursAdmin')

    this.icons[Roles.SUPER_USER] = 'midasMagicWand1'
    this.icons[Roles.STORE_MANAGER] = 'midasProfile1'
    this.icons[Roles.STORE_SALES] = 'midasCashRegister'
    this.icons[Roles.STORE_SALES_LIMITED] = 'midasCashRegister'
    this.icons[Roles.FINANCE] = 'midasBalance'
    this.icons[Roles.WAREHOUSE] = 'midasBox1'
    this.icons[Roles.RESURS_ADMIN] = 'midasAward6'

    this.colors[Roles.SUPER_USER] = 'blue'
    this.colors[Roles.STORE_MANAGER] = 'orange'
    this.colors[Roles.STORE_SALES] = 'green'
    this.colors[Roles.STORE_SALES_LIMITED] = 'green'
    this.colors[Roles.FINANCE] = 'pink'
    this.colors[Roles.WAREHOUSE] = 'purple'
    this.colors[Roles.RESURS_ADMIN] = 'black'
  }
}

export const getRoleIds = () => {
  const roleIds = []
  Object.keys(Roles).forEach(roleId => {
    roleIds.push(roleId)
    return null
  })
  return roleIds
}

export const getRoleNames = () => {
  const roleNames = []
  const roleLabels = new RoleLabels()
  Object.keys(Roles).forEach(roleId => {
    roleNames.push(roleLabels.labels[roleId])
    return null
  })
  return roleNames
}

export const getRoleName = id => {
  const roleIds = Object.keys(Roles)
  const roleLabels = new RoleLabels()
  for (let i = 0; i < roleIds.length; i += 1) {
    if (Roles[roleIds[i]] === id) {
      return roleLabels.labels[roleIds[i]]
    }
  }
  return null
}

export const initRoles = (validRoles, loggedInUser) => {
  const roleLabels = new RoleLabels()
  const _roles =
    loggedInUser.role === Roles.RESURS_ADMIN
      ? validRoles
      : validRoles.filter(({ authorities }) =>
          authorities.every(authority =>
            loggedInUser.authorities.includes(authority),
          ),
        )
  return _roles.map((validRole, index) => ({
    key: index,
    value: validRole.name,
    valueLabel: roleLabels.labels[validRole.name],
  }))
}

export const CartItemMergeParamsValidRoles = [
  Roles.RESURS_ADMIN,
  Roles.SUPER_USER,
]
